import React, { useEffect, useState } from 'react';
import { HomePage } from './pages/HomePage';
import { ApplyPage } from './pages/ApplyPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsPage } from './pages/TermsPage';
import { DisclaimerPage } from './pages/DisclaimerPage';
export function App() {
  const [currentPath, setCurrentPath] = useState(window.location.hash);
  useEffect(() => {
    const handleHashChange = () => {
      setCurrentPath(window.location.hash);
    };
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);
  // Simple routing based on hash
  if (currentPath === '#apply') {
    return <ApplyPage data-id="element-0" />;
  }
  if (currentPath === '#disclaimer') {
    return <DisclaimerPage data-id="element-1" />;
  }
  if (currentPath === '#terms') {
    return <TermsPage data-id="element-2" />;
  }
  if (currentPath === '#privacy') {
    return <PrivacyPolicyPage data-id="element-3" />;
  }
  return <HomePage data-id="element-4" />;
}